import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { LoadingService } from '../shared/loading/loading-service.service';
import { HttpClient } from '@angular/common/http';
import { LoggingService } from '../shared/services/logging/logging.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../store';
import { PostingType } from '../lookups';
import { Observable } from 'rxjs';
import { Account } from './store/account.model';
import { map } from 'rxjs/operators';
import { IGenericResponse, ResponseStatus } from '../shared';
import { AccountContract } from './store/account-contract.model';
import { getTestServiceError } from '../shared';

@Injectable({
    providedIn: 'root'
})
export class AccountService extends LoadingService {
    private uri = `${environment.apiLocation}/Account`;
    private contractUri = `${environment.apiLocation}/ContractARAccount`;
    constructor(
        private http: HttpClient,
        protected log: LoggingService,
        protected rootStore: Store<fromRoot.CoreState>
    ) {
        super(rootStore);
    }
    get(accountType?: string, laborType?: string): Observable<Account[]> {
        let _url = `${this.uri}/?a=1`;
        //if (accountType) {
            _url = _url.concat(`&accountType=${accountType}`);
        //}
        if (laborType) {
            _url = _url.concat(`&laborType=${laborType}`);
        }
        this.log.verbose({
            type: 'AccountService.get',
            accountType,
            laborType,
            _url
        });
        return this.http.get<Account[]>(_url).pipe(
            map(res =>
                res.map(x => ({
                    ...x,
                    Status: {
                        StatusCode: x && x.Status ? x.Status.StatusCode : 0,
                        Message: x && x.Status ? x.Status.Message : '',
                        MsgEntityID:
                            x && x.Status
                                ? x.Status.MsgEntityID
                                : x.AccountListID
                    }
                }))
            )
        );
    }

    getContractARAccounts(): Observable<AccountContract[]> {
        return this.http.get<AccountContract[]>(this.contractUri);
    }
    putContractARAccounts(
        contracts: AccountContract[]
    ): Observable<IGenericResponse<AccountContract>> {
        // return getTestServiceError<AccountContract>(19, contracts as AccountContract[], 'Contractlistid');

        return this.http.put<IGenericResponse<AccountContract>>(
            this.contractUri,
            {
                ContractARAccountList: contracts
            }
        );
    }
}
